import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Sparkles } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);
    setLoading(false);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFAF4] flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="/assets/logo-harmony.jpg"
            alt="Harmony Parfumerie"
            className="h-24 w-24 mx-auto mb-4 rounded-full object-cover shadow-lg"
          />
          <h1
            className="text-4xl font-light text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
          >
            Harmony Parfumerie
          </h1>
          <p className="text-[#332724] font-light mt-2">Administration</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-lg border border-gold shadow-[0_8px_32px_rgba(92, 32, 24,0.05)]"
          data-testid="admin-login-form"
        >
          <h2 className="text-2xl mb-6 text-[#332724]">Connexion</h2>

          {error && (
            <div
              className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 text-sm"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm uppercase tracking-[0.2em] mb-2 text-[#332724]">
              Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full p-3 border border-[#B8922A]/20 rounded-lg focus:outline-none focus:border-[#1E7A6A]"
              required
              data-testid="admin-email"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm uppercase tracking-[0.2em] mb-2 text-[#332724]">
              Mot de passe
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full p-3 border border-[#B8922A]/20 rounded-lg focus:outline-none focus:border-[#1E7A6A]"
              required
              data-testid="admin-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary px-8 py-3 rounded-full font-medium uppercase tracking-[0.2em] text-sm disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
